import React from 'react';
import './Onboarding.css';

function SeriesQuestion({ medium, onSelect }) {
    const label = 'novel';

    return (
        <div className="series-question">
            <h2>One more thing...</h2>

            <div className="series-options">
                <button
                    className="series-option"
                    onClick={() => onSelect({ isSeries: false })}
                >
                    <span className="series-option__title">Standalone {label}</span>
                    <span className="series-option__description">
                        A single, complete story.
                    </span>
                </button>

                <button
                    className="series-option"
                    onClick={() => onSelect({ isSeries: true })}
                >
                    <span className="series-option__title">Part of a series</span>
                    <span className="series-option__description">
                        Multiple books in the same world or with continuing characters.
                    </span>
                </button>

                <button
                    className="series-option"
                    onClick={() => onSelect({ isSeries: false, unsure: true })}
                >
                    <span className="series-option__title">Not sure yet</span>
                    <span className="series-option__description">
                        Start with one story. You can make it a series later.
                    </span>
                </button>
            </div>
        </div>
    );
}

export default SeriesQuestion;
